/* =========================================================================
   kw-lp.js — Kewlioo landing-page runtime (block-based page builder) — v4
   Document-scoped: blocks render inside one section but query the document so
   arrangement/reordering never matters. Drives pack/size selection (multiple
   size groups stay in sync), a swipeable gallery slider (+ idle prefetch),
   the 14-day grid, the sticky bar, smooth-scroll CTAs, direct-to-checkout
   (/cart/add.js -> /discount/CODE?redirect=/checkout), and a guarded
   product-viewed event. Re-inits on shopify:section:load for the theme editor.
   Size-guide open/close is handled by module-size-chart.js (not here).
   ========================================================================= */
(function () {
  'use strict';
  if (window.__kwLpInit) return;   // idempotent: safe if loaded twice (theme.liquid + section)
  window.__kwLpInit = true;
  /* Stop the browser from yanking scroll back to the top after load (scroll-restoration overriding a
     shopper who scrolled while the page was still rendering). NOTE: this also turns off back/forward
     scroll restoration for the tab — remove this one line if you rely on that. */
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
  function $(s, c){ return (c || document).querySelector(s); }
  function $all(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var stickyBound = false;
  var viewFired   = false;

  function scrollToEl(el, topOffset){
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (r.top >= 80 && r.bottom <= window.innerHeight) return; // already visible — don't jump
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - (topOffset || 100)), behavior: 'smooth' });
  }
  function scrollToOffer(){
    var off = $('#kw-offer');
    if (!off) return;
    window.scrollTo({ top: Math.max(0, off.getBoundingClientRect().top + window.pageYOffset - 60), behavior: 'smooth' });
  }

  /* ---------- sticky reveal ---------- */
  function initSticky(){
    if (stickyBound) return;
    stickyBound = true;
    function onScroll(){
      var sticky = $('[data-kw-sticky]');
      if (!sticky) return;
      var anchor = $('.asseen') || $('.hero');
      var offer  = $('#kw-offer');
      var past   = anchor ? (anchor.getBoundingClientRect().bottom < 0) : (window.pageYOffset > 600);
      var inOffer = false;
      if (offer){ var o = offer.getBoundingClientRect(); inOffer = (o.top < window.innerHeight && o.bottom > 0); }
      var show = past && !inOffer;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', String(!show));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- gallery slider (scroll-snap, swipeable) ---------- */
  function initGallery(){
    $all('[data-kw-gallery]').forEach(initOneGallery);
  }
  function initOneGallery(slider){
    var track = $('[data-kw-gtrack]', slider);
    if (!track || track.__kwBound) return;
    track.__kwBound = true;

    var slides   = $all('.gslide', track);
    var scope    = slider.parentElement || slider;                 // thumbs/dots sit next to the slider
    var dotsWrap = $('[data-kw-gdots]', slider) || $('[data-kw-gdots]', scope);
    var thumbs   = $all('[data-kw-thumb]', scope);
    var prev     = $('[data-kw-gprev]', slider);
    var next     = $('[data-kw-gnext]', slider);

    if (slides.length <= 1){
      if (dotsWrap) dotsWrap.style.display = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    if (dotsWrap && !dotsWrap.children.length){
      slides.forEach(function (_, i){
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'gdot';
        d.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        d.setAttribute('aria-label', 'Go to image ' + (i + 1));
        d.addEventListener('click', function (){ goTo(i); });
        dotsWrap.appendChild(d);
      });
    }
    var dots = dotsWrap ? $all('.gdot', dotsWrap) : [];

    function updateArrows(i){
      if (prev) prev.style.visibility = i <= 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = i >= slides.length - 1 ? 'hidden' : 'visible';
    }
    function setActive(i){
      dots.forEach(function (d, di){ d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
      thumbs.forEach(function (t){ t.setAttribute('aria-current', (+t.getAttribute('data-kw-thumb')) === i ? 'true' : 'false'); });
      updateArrows(i);
    }
    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function current(){ return Math.round(track.scrollLeft / track.clientWidth); }

    var raf;
    track.addEventListener('scroll', function (){
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function (){ setActive(Math.max(0, Math.min(slides.length - 1, current()))); });
    }, { passive: true });

    thumbs.forEach(function (t){ t.addEventListener('click', function (){ goTo(+t.getAttribute('data-kw-thumb')); }); });
    if (prev) prev.addEventListener('click', function (){ goTo(current() - 1); });
    if (next) next.addEventListener('click', function (){ goTo(current() + 1); });
    setActive(0);

    /* Swiping is native horizontal scroll-snap (works both directions, with momentum).
       touch-action on .gtrack (CSS) keeps vertical page-scroll and blocks double-tap/pinch zoom. */
    slides.forEach(function (s){ var im = s.querySelector('img'); if (im) im.draggable = false; });

    /* idle-prefetch the next couple of slides so switching is instant (bounded to limit bandwidth) */
    var warm = function (){
      slides.forEach(function (s, idx){
        if (idx === 0 || idx > 2) return;          // only slides 2 and 3
        var img = s.querySelector('img');
        if (!img) return;
        var url = img.currentSrc || img.getAttribute('src');
        if (url){ var pre = new Image(); pre.src = url; }
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 1200);
  }

  /* ---------- demo video: buffer when the shopper gets close, autoplay only while in view ---------- */
  function initInViewVideos(){
    var vids = $all('video[data-kw-autoplay]');
    if (!vids.length) return;
    function warm(v){ if (v.preload !== 'auto'){ v.preload = 'auto'; try { v.load(); } catch (e) {} } }

    vids.forEach(function (v){
      if (v.__kwAuto) return; v.__kwAuto = true;
      if ('IntersectionObserver' in window){
        /* start downloading only when within ~1.5 screens — saves CDN bandwidth on bounces and
           avoids a post-load spike, while still being ready by the time it scrolls into view */
        var pre = new IntersectionObserver(function (ents){
          ents.forEach(function (e){ if (e.isIntersecting){ warm(e.target); pre.disconnect(); } });
        }, { rootMargin: '0px 0px 150% 0px' });
        pre.observe(v);
        /* play only while actually on screen; pause when it leaves */
        var play = new IntersectionObserver(function (ents){
          ents.forEach(function (e){
            if (e.isIntersecting){ warm(e.target); var p = e.target.play(); if (p && p.catch) p.catch(function (){}); }
            else { e.target.pause(); }
          });
        }, { threshold: 0.25 });
        play.observe(v);
      } else {
        warm(v); var p = v.play(); if (p && p.catch) p.catch(function (){});
      }
    });
  }

  /* ---------- thermal compare: center the VS badge on the thermal row ---------- */
  function initThermalVs(){
    var wrap = $('.tcompare'); if (!wrap) return;
    var vs = $('.tcw-vs', wrap);
    var card = $('.tcw.hot .tcard', wrap) || $('.tcw .tcard', wrap);
    if (!vs || !card) return;
    function place(){
      var wr = wrap.getBoundingClientRect(), cr = card.getBoundingClientRect();
      vs.style.top = (cr.top - wr.top + cr.height / 2) + 'px';
    }
    place();
    if (!wrap.__kwVs){
      wrap.__kwVs = true;
      window.addEventListener('resize', place);
      window.addEventListener('load', place, { once: true });
      if (window.ResizeObserver){ try { new ResizeObserver(place).observe(wrap); } catch (e) {} }
    }
  }

  /* ---------- thermal compare: animate timer + temperature + heat, synced to scroll/video ---------- */
  function initThermalRun(){
    var wrap = $('.tcompare'); if (!wrap || wrap.__kwRun) return; wrap.__kwRun = true;
    var cards = $all('.tcard', wrap); if (!cards.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    cards.forEach(function (c){
      var tEl = $('.ttemp', c), timeEl = $('.thd-time', c);
      if (tEl){
        var m = (tEl.textContent || '').match(/(-?[\d.]+)(.*)/);
        if (m){ var dec = (m[1].split('.')[1] || '').length; var tgt = parseFloat(m[1]);
          c.__temp = { el: tEl, target: tgt, suf: m[2] || '', dec: dec,
            start: Math.max(0, tgt - (c.classList.contains('hot') ? 20 : 12)) }; }
      }
      if (timeEl){
        var ts = (timeEl.textContent || '').trim(), sec, colon = ts.indexOf(':') > -1;
        if (colon){ var p = ts.split(':'); sec = (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0); }
        else sec = parseInt(ts, 10) || 0;
        c.__time = { el: timeEl, target: sec, colon: colon, pad: colon ? (ts.split(':')[0] || '').length : 0 };
      }
    });

    function fmtTime(sec, t){
      if (!t.colon) return String(Math.round(sec));
      var mm = Math.floor(sec / 60), ss = Math.floor(sec % 60);
      return ('' + mm).padStart(Math.max(2, t.pad), '0') + ':' + ('' + ss).padStart(2, '0');
    }
    function paintCard(c, p){
      var h = c.classList.contains('hot') ? heatHot(p) : heatCool(p);
      if (c.__temp){ var v = c.__temp.start + (c.__temp.target - c.__temp.start) * h;
        c.__temp.el.textContent = v.toFixed(c.__temp.dec) + c.__temp.suf; }
      if (c.__time){ c.__time.el.textContent = fmtTime(c.__time.target * p, c.__time); }  // timer = session progress
      c.style.setProperty('--heat', h.toFixed(3));
    }
    function smooth(x){ x = Math.min(1, Math.max(0, x)); return x * x * (3 - 2 * x); }
    /* heat vs session progress p (0..1) — different physics per garment */
    function heatHot(p){                    // rises hard in first ~10% (≈3-5 of 45 min), then creeps to max
      if (p < 0.10) return smooth(p / 0.10) * 0.9;
      return Math.min(1, 0.9 + (p - 0.10) / 0.90 * 0.1);
    }
    function heatCool(p){                    // gentle, slow climb the whole session — never as dramatic as the hoodie
      return smooth(p);
    }
    function update(p){ cards.forEach(function (c){ paintCard(c, p); }); }

    if (reduce){ update(1); return; }       // reduced motion: show the end state, no animation
    update(0);

    var vid = $('video[data-kw-autoplay]');
    var raf = null, loopStart = 0, LOOP = 9000;
    function tick(now){
      var p;
      if (vid && vid.duration && isFinite(vid.duration)) p = vid.currentTime / vid.duration;  // synced to video time
      else { if (!loopStart) loopStart = now; p = ((now - loopStart) % LOOP) / LOOP; }         // no video: virtual loop
      update(p);
      raf = requestAnimationFrame(tick);
    }
    function start(){ if (!raf){ loopStart = 0; raf = requestAnimationFrame(tick); } }
    function stop(){ if (raf){ cancelAnimationFrame(raf); raf = null; } }

    if ('IntersectionObserver' in window){
      new IntersectionObserver(function (ents){
        ents.forEach(function (e){ if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.25 }).observe(wrap);
    } else { start(); }
  }

  /* ---------- review photo lightbox (gallery) ---------- */
  var __kwLbEl = null, __kwLbList = [], __kwLbIdx = 0;
  function kwLbWidth(){
    var w = Math.round((window.innerWidth || 360) * (window.devicePixelRatio || 1));
    if (w < 600) w = 600; if (w > 1600) w = 1600;
    return w;
  }
  function kwLbSized(url){
    if (!url) return url;
    var w = kwLbWidth();
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function kwLbBuild(){
    if (__kwLbEl) return __kwLbEl;
    var el = document.createElement('div');
    el.className = 'kw-lb'; el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="kw-lb-bg" data-kw-lb-close></div>' +
      '<div class="kw-lb-spin" data-kw-lb-spin aria-hidden="true"></div>' +
      '<button type="button" class="kw-lb-x" data-kw-lb-close aria-label="Close">\u00d7</button>' +
      '<button type="button" class="kw-lb-nav kw-lb-prev" data-kw-lb-prev aria-label="Previous">\u2039</button>' +
      '<figure class="kw-lb-fig"><img class="kw-lb-img" data-kw-lb-img alt="" decoding="async"><figcaption class="kw-lb-cap" data-kw-lb-cap></figcaption></figure>' +
      '<div class="kw-lb-cta" data-kw-lb-cta-slot></div>' +
      '<button type="button" class="kw-lb-nav kw-lb-next" data-kw-lb-next aria-label="Next">\u203a</button>' +
      '<div class="kw-lb-count" data-kw-lb-count></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e){ if (e.target.hasAttribute && e.target.hasAttribute('data-kw-lb-close')) kwLbClose(); });
    el.querySelector('[data-kw-lb-prev]').addEventListener('click', function (){ kwLbShow(__kwLbIdx - 1); });
    el.querySelector('[data-kw-lb-next]').addEventListener('click', function (){ kwLbShow(__kwLbIdx + 1); });
    document.addEventListener('keydown', function (e){
      if (!__kwLbEl || __kwLbEl.hasAttribute('hidden')) return;
      if (e.key === 'Escape') kwLbClose();
      else if (e.key === 'ArrowLeft') kwLbShow(__kwLbIdx - 1);
      else if (e.key === 'ArrowRight') kwLbShow(__kwLbIdx + 1);
    });
    var sx = 0;
    el.addEventListener('touchstart', function (e){ sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e){ var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) kwLbShow(dx < 0 ? __kwLbIdx + 1 : __kwLbIdx - 1); });
    __kwLbEl = el; kwLbCta(); return el;
  }
  function kwLbCta(){
    if (!__kwLbEl) return;
    var slot = __kwLbEl.querySelector('[data-kw-lb-cta-slot]');
    if (!slot) return;
    var c = document.querySelector('[data-kw-lbcta]');
    if (!c){ slot.innerHTML = ''; __kwLbEl.classList.remove('has-cta'); return; }
    var label = c.getAttribute('data-label') || 'Shop now';
    var url = c.getAttribute('data-url') || '';
    var sub = c.getAttribute('data-sub') || '';
    var inner = '<span class="kw-lb-cta-main">' + label + '</span>' + (sub ? ('<span class="kw-lb-cta-sub">' + sub + '</span>') : '');
    if (url){
      slot.innerHTML = '<a class="kw-lb-cta-btn' + (sub ? ' two' : '') + '" href="' + url + '">' + inner + '</a>';
    } else {
      slot.innerHTML = '<button type="button" class="kw-lb-cta-btn' + (sub ? ' two' : '') + '" data-kw-lb-scroll>' + inner + '</button>';
      var b = slot.querySelector('[data-kw-lb-scroll]');
      if (b) b.addEventListener('click', function (){ kwLbClose(); scrollToOffer(); });
    }
    __kwLbEl.classList.add('has-cta');
  }
  function kwLbShow(i){
    var n = __kwLbList.length; if (!n) return;
    __kwLbIdx = (i + n) % n; var it = __kwLbList[__kwLbIdx];
    var img = __kwLbEl.querySelector('[data-kw-lb-img]');
    __kwLbEl.classList.add('loading');
    img.onload = function (){ __kwLbEl.classList.remove('loading'); };
    img.onerror = function (){ __kwLbEl.classList.remove('loading'); };
    img.src = kwLbSized(it.full); img.alt = it.cap || '';
    if (img.complete && img.naturalWidth) __kwLbEl.classList.remove('loading');
    var cap = __kwLbEl.querySelector('[data-kw-lb-cap]'); cap.textContent = it.cap || ''; cap.style.display = it.cap ? '' : 'none';
    __kwLbEl.querySelector('[data-kw-lb-count]').textContent = (__kwLbIdx + 1) + ' / ' + n;
    var nav = n > 1 ? '' : 'none';
    __kwLbEl.querySelector('[data-kw-lb-prev]').style.display = nav;
    __kwLbEl.querySelector('[data-kw-lb-next]').style.display = nav;
    if (n > 1){
      [(__kwLbIdx + 1) % n, (__kwLbIdx - 1 + n) % n].forEach(function (k){ var nb = __kwLbList[k]; if (nb){ var im = new Image(); im.src = kwLbSized(nb.full); } });
    }
  }
  function kwLbOpen(list, i){ kwLbBuild(); __kwLbList = list; kwLbShow(i); __kwLbEl.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
  function kwLbClose(){ if (__kwLbEl){ __kwLbEl.setAttribute('hidden', ''); document.body.style.overflow = ''; } }
  function initLightbox(){
    var zoom = $all('[data-kw-zoom]');
    if (!zoom.length) return;
    zoom.forEach(function (elm){
      if (elm.__kwZoom) return; elm.__kwZoom = true;
      elm.addEventListener('click', function (){
        var all = $all('[data-kw-zoom]');
        var list = all.map(function (x){ return { full: x.getAttribute('data-full') || x.src, cap: x.getAttribute('data-cap') || '' }; });
        kwLbOpen(list, all.indexOf(elm));
      });
      elm.addEventListener('keydown', function (e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); elm.click(); } });
    });
  }


  /* ---------- bundle offer (two-product tiers) ---------- */
  function initBundle(){
    var el = document.querySelector('[data-kwb-config]');
    if (!el) return;
    var C; try { C = JSON.parse(el.textContent); } catch (e){ return; }
    var root = el.closest('.kwb') || document;
    if (!C.tiers || !C.tiers.length) return;
    /* hero mirror: clone the buy UI into [data-kwb-hero] and hide the hero's scroll CTA */
    var heroBox = document.querySelector('[data-kwb-hero]');
    if (heroBox && root !== document){
      ['.kwb-tiers', '.kwb-selhead', '.kwb-selectors', '[data-kwb-warn]', '[data-kwb-shipline]', '.kwb-cash', '[data-kwb-cta]', '.payicons'].forEach(function (sel){
        var n = root.querySelector(sel);
        if (n) heroBox.appendChild(n.cloneNode(true));
      });
      heroBox.hidden = false;
      var wrap = heroBox.parentElement;
      if (wrap) Array.prototype.slice.call(wrap.querySelectorAll('a.cta, .cta-note')).forEach(function (x){ x.style.display = 'none'; });
      Array.prototype.slice.call(heroBox.querySelectorAll('.open-size-chart')).forEach(function (btn){
        btn.addEventListener('click', function (){
          var sc = document.querySelector('size-chart');
          if (sc){ sc.setAttribute('open', ''); document.body.classList.add('size-chart-open'); }
        });
      });
    }
    var tiers = Array.prototype.slice.call(document.querySelectorAll('[data-kwb-tier]'));
    if (!tiers.length) return;
    var st = { t: C.defaultTier || 0, colA: (C.a.colors[0] || ''), colB: (C.b.colors[0] || ''), szA: null, szB: null };
    function fmt(c){ try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: C.currency || 'USD' }).format((c || 0) / 100); } catch (e){ return '$' + ((c || 0) / 100).toFixed(2); } }
    function tier(){ return C.tiers[st.t] || C.tiers[0]; }
    function colorsFor(P, qty, chosen){
      if (!P.colors.length){ var e = []; for (var k = 0; k < qty; k++) e.push(''); return e; }
      if (qty <= 1 || P.colors.length === 1){ var c = chosen || P.colors[0], out = []; for (var i = 0; i < qty; i++) out.push(c); return out; }
      var out2 = []; for (var j = 0; j < qty; j++) out2.push(P.colors[j % 2]); return out2;
    }
    function linesFor(P, qty, chosen, sizeH){
      var cs = colorsFor(P, qty, chosen), ids = [];
      for (var i = 0; i < cs.length; i++){
        var v = P.vmap[cs[i] + '|' + (sizeH || '')];
        if (!v || !v.av) return null;
        ids.push(v.id);
      }
      return ids;
    }
    function sizeOk(P, qty, chosen, sizeH){ return !!linesFor(P, qty, chosen, sizeH); }
    function q(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }
    function rows(key){ return { colors: q('[data-kwb-colors="' + key + '"]'), sizes: q('[data-kwb-sizes="' + key + '"]'), mix: q('[data-kwb-mix="' + key + '"]') }; }
    function renderProd(key){
      var P = C[key], t = tier(), qty = key === 'a' ? t.qa : t.qb;
      var chosen = key === 'a' ? st.colA : st.colB;
      var R = rows(key);
      var mixMode = qty > 1 && P.colors.length > 1;
      R.colors.forEach(function (c){
        c.style.display = (mixMode || P.colors.length <= 1) ? 'none' : '';
        Array.prototype.slice.call(c.querySelectorAll('[data-kwb-color]')).forEach(function (p){
          p.classList.toggle('sel', p.getAttribute('data-kwb-color') === chosen);
        });
      });
      R.mix.forEach(function (m){ m.hidden = !mixMode; });
      q('[data-kwb-img="' + key + '"]').forEach(function (img){
        var want = (!mixMode && P.cimg && P.cimg[chosen]) ? P.cimg[chosen] : img.getAttribute('data-def');
        if (want && img.getAttribute('src') !== want) img.setAttribute('src', want);
      });
      var cur = key === 'a' ? st.szA : st.szB, curOk = false;
      R.sizes.forEach(function (sz){
        Array.prototype.slice.call(sz.querySelectorAll('[data-kwb-size]')).forEach(function (p){
          var h = p.getAttribute('data-kwb-size');
          var ok = sizeOk(P, qty, chosen, h);
          p.disabled = !ok; p.classList.toggle('soldout', !ok);
          var sel = ok && h === cur;
          p.classList.toggle('sel', sel);
          if (sel) curOk = true;
        });
      });
      if (!curOk){ if (key === 'a') st.szA = null; else st.szB = null; }
    }
    function renderTiers(){
      tiers.forEach(function (tc){ var on = (parseInt(tc.getAttribute('data-idx'), 10) || 0) === st.t; tc.classList.toggle('on', on); tc.setAttribute('aria-checked', on ? 'true' : 'false'); });
      q('[data-kwb-price]').forEach(function (pr){ pr.textContent = ' \u00b7 ' + fmt(tier().finalCents); });
      q('[data-kwb-shipline]').forEach(function (sl){ sl.hidden = !tier().ship; });
      if (window.KWCB && window.KWCB.setTotal) window.KWCB.setTotal(tier().finalCents);
    }
    function warn(show){ q('[data-kwb-warn]').forEach(function (w){ w.hidden = !show; }); }
    function renderAll(){ renderTiers(); renderProd('a'); renderProd('b'); }
    tiers.forEach(function (tc){
      function pick(){ st.t = parseInt(tc.getAttribute('data-idx'), 10) || 0; warn(false); renderAll(); }
      tc.addEventListener('click', pick);
      tc.addEventListener('keydown', function (e){ if (e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); pick(); } });
    });
    ['a', 'b'].forEach(function (key){
      var R = rows(key);
      R.colors.forEach(function (c){
        Array.prototype.slice.call(c.querySelectorAll('[data-kwb-color]')).forEach(function (p){
          p.addEventListener('click', function (){
            if (key === 'a') st.colA = p.getAttribute('data-kwb-color'); else st.colB = p.getAttribute('data-kwb-color');
            renderProd(key);
          });
        });
      });
      R.sizes.forEach(function (sz){
        Array.prototype.slice.call(sz.querySelectorAll('[data-kwb-size]')).forEach(function (p){
          p.addEventListener('click', function (){
            if (p.disabled) return;
            if (key === 'a') st.szA = p.getAttribute('data-kwb-size'); else st.szB = p.getAttribute('data-kwb-size');
            warn(false); renderProd(key);
          });
        });
      });
    });
    q('[data-kwb-cta]').forEach(function (cta){
    cta.addEventListener('click', function (){
      var t = tier();
      if ((C.a.hasSize && !st.szA) || (C.b.hasSize && !st.szB)){
        warn(true);
        var sr = cta.closest('.kw-hbb, .kwb') || document;
        var sel = sr.querySelector('.kwb-selectors');
        if (sel) sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var la = linesFor(C.a, t.qa, st.colA, st.szA || '');
      var lb = linesFor(C.b, t.qb, st.colB, st.szB || '');
      if (!la || !lb){ warn(true); return; }
      cta.classList.add('is-busy');
      var ids = la.concat(lb);
      var items = ids.map(function (id){ return id + ':1'; }).join(',');
      var code = tier().code || C.code || '';
      var permalink = '/cart/' + items + (code ? ('?discount=' + encodeURIComponent(code)) : '');
      var target = '/checkout';
      var dest = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target)) : target;
      var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      var itemsArr = ids.map(function (id){ return { id: id, quantity: 1 }; });
      function goAdd(){
        fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: itemsArr }) })
          .then(function (){ window.location.href = dest; })
          .catch(function (){ window.location.href = permalink; });
      }
      var T = C.orderTag;
      if (T && T.enabled){
        var attrs = { '_lp': '1', '_lp_product': T.product || '', '_lp_template': T.template || '', '_lp_url': T.url || location.pathname };
        var pre = (C.buyNow !== false)
          ? fetch('/cart/clear.js', { method: 'POST', headers: H }).catch(function (){})
          : Promise.resolve();
        pre.then(function (){ return fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: attrs }) }); }).then(goAdd).catch(goAdd);
        return;
      }
      if (C.buyNow !== false){ window.location.href = permalink; return; }
      goAdd();
    });
    });
    renderAll();
  }

  function init(){
    var lp = $('.kw-lp');
    if (!lp) return;

    /* 14-day grid */
    var grid = $('[data-kw-grid14]');
    if (grid && !grid.children.length){
      for (var i = 1; i <= 14; i++){
        var d = document.createElement('div');
        d.className = 'day' + (i <= 2 ? ' lit' : '');
        d.textContent = i;
        grid.appendChild(d);
      }
    }

    initGallery();
    initInViewVideos();
    initThermalVs();
    initThermalRun();

    /* smooth-scroll CTAs (work with or without an offer block) */
    $all('[data-kw-scroll]').forEach(function (a){
      if (a.__kwScroll) return; a.__kwScroll = true;
      a.addEventListener('click', function (e){ e.preventDefault(); scrollToOffer(); });
    });

    /* "Read more" CTAs that scroll to a chosen section (any CSS selector) */
    $all('[data-kw-scroll-target]').forEach(function (a){
      if (a.__kwScrollT) return; a.__kwScrollT = true;
      a.addEventListener('click', function (e){
        var sel = a.getAttribute('data-kw-scroll-target'); if (!sel) return;
        var el = null; try { el = document.querySelector(sel); } catch (err) {}
        if (el){ e.preventDefault(); scrollToEl(el, 70); }
      });
    });

    initLightbox();
    initBundle();

    /* ---------- config-driven offer ---------- */
    var cfgEl = $('[data-kw-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e){ return; }
    if (!cfg.packs || !cfg.packs.length) return;

    var byId = {};
    cfg.packs.forEach(function (p){ byId[p.id] = p; });

    var state = { packId: cfg.defaultPackId || cfg.packs[0].id, size: null };

    var elPacks    = $('[data-kw-packs]');
    var sizeGroups = $all('[data-kw-sizes]');
    var warns      = $all('[data-kw-sizewarn]');
    var elValue    = $('[data-kw-value]');
    var elToday    = $('[data-kw-today]');
    var elSave     = $('[data-kw-save]');
    var rowSave    = $('[data-kw-saveline]');
    var rowProg    = $('[data-kw-progline]');
    var elProgVal  = $('[data-kw-progval]');
    var rowShip    = $('[data-kw-shipline]');
    var elShipVal  = $('[data-kw-shipval]');
    var elHeroNow  = $('[data-kw-hero-now]');
    var elHeroWas  = $('[data-kw-hero-was]');
    var ctas       = $all('[data-kw-cta]');
    var ctaLabels  = $all('[data-kw-cta-label]');
    var ctaSubs    = $all('[data-kw-cta-sub]');
    var elStName   = $('[data-kw-sticky-name]');
    var elStNow    = $('[data-kw-sticky-now]');
    var elStWas    = $('[data-kw-sticky-was]');
    var elStBtn    = $('[data-kw-sticky-btn]');

    /* ---------- upsell add-on + free-shipping bar ---------- */
    var A          = cfg.addon || null;
    var addonBoxes = $all('[data-kw-addon]');
    var shipBars   = $all('[data-kw-shipbar]');
    state.addonAdded = !!(A && A.checkedDefault);
    state.addonSize  = null;
    if (A && A.sizeOpt > 0 && A.sizes && A.sizes.length){
      for (var _ai = 0; _ai < A.sizes.length; _ai++){ if (A.sizes[_ai].available){ state.addonSize = A.sizes[_ai].handle; break; } }
      if (!state.addonSize) state.addonSize = A.sizes[0].handle;
    }
    function fmtMoney(cents){
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD' }).format((cents || 0) / 100); }
      catch (e){ return '$' + ((cents || 0) / 100).toFixed(2); }
    }
    function addonVariantId(){
      if (!A) return 0;
      var i;
      if (A.sizeOpt > 0 && A.sizes && A.sizes.length){
        for (i = 0; i < A.sizes.length; i++){ if (A.sizes[i].handle === state.addonSize) return A.sizes[i].id; }
        for (i = 0; i < A.sizes.length; i++){ if (A.sizes[i].available) return A.sizes[i].id; }
      }
      return A.defaultVariantId || 0;
    }
    function orderCents(){ var c = (pack().priceCents) || 0; if (state.addonAdded && A) c += (A.priceCents || 0); return c; }
    function shipUnlocked(){
      if (cfg.shipBar && cfg.shipBar.goalCents > 0) return orderCents() >= cfg.shipBar.goalCents;
      return false;
    }
    function addonShipState(){
      if (!A || !cfg.shipBar || !cfg.shipBar.enabled) return 'none';
      var goal = cfg.shipBar.goalCents || 0;
      if (goal <= 0) return 'none';
      var base = (pack().priceCents) || 0;
      if (base >= goal) return 'none';                        /* order already qualifies without the add-on */
      if (base + (A.priceCents || 0) < goal) return 'none';   /* add-on still doesn't reach the goal */
      return state.addonAdded ? 'unlocked' : 'willUnlock';
    }
    function shipBarHTML(){
      var goal = cfg.shipBar.goalCents || 0, cur = orderCents(), unlocked = shipUnlocked();
      var pctNum = goal > 0 ? Math.min(100, Math.round(cur / goal * 100)) : 100;
      return unlocked
        ? '<div class="kw-sb-row"><span class="kw-sb-ico">\u2713</span> You\u2019ve unlocked <b>FREE shipping</b></div><div class="kw-sb-track"><span class="kw-sb-fill" style="width:100%"></span></div>'
        : '<div class="kw-sb-row">You\u2019re <b>' + fmtMoney(Math.max(0, goal - cur)) + '</b> away from <b>FREE shipping</b></div><div class="kw-sb-track"><span class="kw-sb-fill" style="width:' + pctNum + '%"></span></div>';
    }
    function renderShipBar(){
      if (window.KWCB && window.KWCB.setTotal) window.KWCB.setTotal(orderCents());
      if (!cfg.shipBar || !cfg.shipBar.enabled || !shipBars.length) return;
      var loc = cfg.shipBar.location || 'page';
      if (loc === 'popup'){ shipBars.forEach(function (b){ b.hidden = true; b.innerHTML = ''; }); return; }
      var html = shipBarHTML(), unlocked = shipUnlocked();
      shipBars.forEach(function (b){ b.innerHTML = html; b.hidden = false; b.classList.toggle('unlocked', unlocked); });
    }
    function addonSizeSelect(idPrefix){
      if (!(A && A.sizeOpt > 0 && A.sizes && A.sizes.length)) return '';
      var out = '<select class="' + idPrefix + '-size" data-' + idPrefix + '-size aria-label="' + (A.sizeLabel || 'Size') + '">';
      A.sizes.forEach(function (s){
        out += '<option value="' + s.handle + '"' + (s.handle === state.addonSize ? ' selected' : '') + (s.available ? '' : ' disabled') + '>' + s.name + (s.available ? '' : ' \u2014 sold out') + '</option>';
      });
      return out + '</select>';
    }
    function renderAddon(){
      if (!A || !A.checkbox || !addonBoxes.length) return;
      var st = addonShipState();
      var badge = st === 'willUnlock' ? '<span class="kw-addon-badge">Unlocks free shipping</span>'
                : st === 'unlocked'   ? '<span class="kw-addon-badge is-on">\u2713 Free shipping unlocked</span>'
                : '';
      var priceHTML = (A.compare ? ('<s>' + A.compare + '</s>') : '') + '<b>' + A.price + '</b>';
      var sizeRow = (A.sizeOpt > 0 && A.sizes && A.sizes.length)
        ? ('<div class="kw-addon-sizewrap"><span class="kw-addon-sizelabel">' + (A.sizeLabel || 'Size') + '</span>' + addonSizeSelect('kw-addon') + '</div>')
        : '';
      var html =
        '<label class="kw-addon-main">' +
          '<input type="checkbox" class="kw-addon-cb" data-kw-addon-cb' + (state.addonAdded ? ' checked' : '') + '>' +
          '<span class="kw-addon-check" aria-hidden="true"></span>' +
          (A.image ? ('<img class="kw-addon-img" src="' + A.image + '" alt="" width="52" height="52">') : '') +
          '<span class="kw-addon-info">' +
            '<span class="kw-addon-t">' + A.title + '</span>' +
            badge +
            (A.pitch ? ('<span class="kw-addon-pitch">' + A.pitch + '</span>') : '') +
          '</span>' +
          '<span class="kw-addon-price">' + priceHTML + '</span>' +
        '</label>' + sizeRow;
      addonBoxes.forEach(function (box){
        box.className = 'kw-addon' + (state.addonAdded ? ' on' : '');
        box.innerHTML = html;
        var cb = box.querySelector('[data-kw-addon-cb]');
        if (cb) cb.addEventListener('change', function (){ state.addonAdded = cb.checked; renderAddon(); renderShipBar(); });
        var sz = box.querySelector('[data-kw-addon-size]');
        if (sz) sz.addEventListener('change', function (){ state.addonSize = sz.value; });
      });
    }

    /* ---------- upsell popup (after Add to cart) ---------- */
    var upEl = null;
    function buildUpsell(){
      if (upEl) return upEl;
      upEl = document.createElement('div');
      upEl.className = 'kw-up';
      upEl.setAttribute('hidden', '');
      upEl.innerHTML =
        '<div class="kw-up-bg" data-kw-up-close></div>' +
        '<div class="kw-up-card" role="dialog" aria-modal="true" aria-label="Add to your order">' +
          '<button type="button" class="kw-up-x" data-kw-up-close aria-label="Close">\u00d7</button>' +
          '<div class="kw-up-title">Wait \u2014 add this to your order?</div>' +
          '<div class="kw-up-bar" data-kw-up-bar></div>' +
          '<div class="kw-up-body" data-kw-up-body></div>' +
          '<div class="kw-up-actions"><button type="button" class="kw-up-add" data-kw-up-add></button>' +
          '<button type="button" class="kw-up-no" data-kw-up-no>No thanks, continue</button></div>' +
        '</div>';
      (lp || document.body).appendChild(upEl);
      if (cfg.buttonColor) upEl.style.setProperty('--kw-btn', cfg.buttonColor);
      upEl.addEventListener('click', function (e){ if (e.target.hasAttribute && e.target.hasAttribute('data-kw-up-close')){ state._upsellDone = true; closeUpsell(); checkout(state._lastBtn); } });
      return upEl;
    }
    function renderUpsell(){
      buildUpsell();
      var body = upEl.querySelector('[data-kw-up-body]');
      var addBtn = upEl.querySelector('[data-kw-up-add]');
      var cmp = A.compare ? ('<s>' + A.compare + '</s> ') : '';
      var barInPopup = !!(cfg.shipBar && cfg.shipBar.enabled && (cfg.shipBar.location === 'popup' || cfg.shipBar.location === 'both'));
      var barSlot = upEl.querySelector('[data-kw-up-bar]');
      if (barInPopup){
        barSlot.innerHTML = '<div class="kw-shipbar' + (shipUnlocked() ? ' unlocked' : '') + '">' + shipBarHTML() + '</div>';
        barSlot.style.display = '';
      } else { barSlot.innerHTML = ''; barSlot.style.display = 'none'; }
      var unlockMsg = (!barInPopup && addonShipState() === 'willUnlock') ? '<div class="kw-up-unlock"><span class="kw-sb-ico">\u2713</span> Gets you <b>FREE shipping</b></div>' : '';
      var upSizeRow = (A.sizeOpt > 0 && A.sizes && A.sizes.length) ? ('<div class="kw-up-sizewrap"><span class="kw-up-sizelabel">' + (A.sizeLabel || 'Size') + '</span>' + addonSizeSelect('kw-up') + '</div>') : '';
      body.innerHTML =
        (A.image ? ('<img class="kw-up-img" src="' + A.image + '" alt="">') : '') +
        '<div class="kw-up-meta"><div class="kw-up-t">' + A.title + '</div>' +
          (A.pitch ? ('<div class="kw-up-pitch">' + A.pitch + '</div>') : '') +
          '<div class="kw-up-p">' + cmp + '<b>' + A.price + '</b></div>' + unlockMsg + upSizeRow +
        '</div>';
      addBtn.innerHTML = 'Yes, add for ' + A.price;
      var sz = upEl.querySelector('[data-kw-up-size]');
      if (sz) sz.addEventListener('change', function (){ state.addonSize = sz.value; });
      addBtn.onclick = function (){ state.addonAdded = true; state._upsellDone = true; renderAddon(); renderShipBar(); closeUpsell(); checkout(state._lastBtn); };
      upEl.querySelector('[data-kw-up-no]').onclick = function (){ state._upsellDone = true; closeUpsell(); checkout(state._lastBtn); };
    }
    function openUpsell(){ renderUpsell(); upEl.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
    function closeUpsell(){ if (upEl){ upEl.setAttribute('hidden', ''); document.body.style.overflow = ''; } }

    function pack(){ return byId[state.packId]; }

    function syncSizeChecked(){
      sizeGroups.forEach(function (group){
        $all('[data-kw-size]', group).forEach(function (x){
          x.setAttribute('aria-checked', x.getAttribute('data-kw-size') === state.size ? 'true' : 'false');
        });
      });
    }
    function clearWarn(){
      warns.forEach(function (w){ w.classList.remove('show'); });
      sizeGroups.forEach(function (g){ g.classList.remove('kw-shake'); });
    }
    function bindSizes(){
      sizeGroups.forEach(function (group){
        $all('[data-kw-size]', group).forEach(function (b){
          b.addEventListener('click', function (){
            if (b.getAttribute('aria-disabled') === 'true') return;
            state.size = b.getAttribute('data-kw-size');
            syncSizeChecked();
            clearWarn();
          });
        });
      });
    }
    function rebuildSizes(){
      var p = pack();
      var ok = p.sizes && p.sizes.some(function (s){ return s.handle === state.size; });
      if (!ok) state.size = null;
      sizeGroups.forEach(function (group){
        var html = '';
        if (p.sizes && p.sizes.length){
          p.sizes.forEach(function (s){
            var v = p.variants[s.handle];
            var avail = !!(v && v.available);
            var sel = s.handle === state.size;
            html += '<button type="button" class="size' + (avail ? '' : ' is-oos') + '" role="radio" aria-checked="' + sel + '" data-kw-size="' + s.handle + '"' + (avail ? '' : ' aria-disabled="true"') + '>' + s.name + '</button>';
          });
        } else {
          html = '<button type="button" class="size" role="radio" aria-checked="false" data-kw-size="">One size</button>';
        }
        group.innerHTML = html;
      });
      bindSizes();
    }

    function selectPack(id){
      if (!byId[id]) return;
      state.packId = id;
      var p = pack();
      if (elPacks){
        $all('[data-kw-pack]', elPacks).forEach(function (b){
          b.setAttribute('aria-checked', String(b.getAttribute('data-kw-pack')) === String(id) ? 'true' : 'false');
        });
      }
      /* hero price */
      if (elHeroNow) elHeroNow.textContent = p.price;
      if (elHeroWas){ if (p.hasCompare){ elHeroWas.style.display = ''; elHeroWas.textContent = p.compare; } else { elHeroWas.style.display = 'none'; } }
      /* price frame */
      if (elValue){ elValue.textContent = p.regular; elValue.style.display = p.hasCompare ? '' : 'none'; }
      if (elToday) elToday.textContent = p.price;
      if (rowProg) rowProg.style.display = p.qualifies ? '' : 'none';
      if (elProgVal){ var _pv = p.progVal || p.progValue || ''; elProgVal.textContent = _pv ? ('FREE \u00b7 ' + _pv + ' value') : 'FREE'; }
      if (rowShip){
        rowShip.style.display = '';
        if (elShipVal){
          if (p.freeShip){ elShipVal.textContent = 'FREE'; elShipVal.classList.add('free'); }
          else { elShipVal.textContent = p.shipFee || ''; elShipVal.classList.remove('free'); }
        }
      }
      if (rowSave){
        if (p.savePct > 0){ rowSave.style.display = ''; if (elSave) elSave.textContent = p.save + ' (' + p.savePct + '%)'; }
        else { rowSave.style.display = 'none'; }
      }
      /* CTAs */
      ctaLabels.forEach(function (el){ el.textContent = 'Get My ' + p.label; });
      ctaSubs.forEach(function (el){ el.textContent = p.qualifies ? '+ Free Program' : ''; });
      /* sticky */
      if (elStNow) elStNow.textContent = p.price;
      if (elStWas){ if (p.hasCompare){ elStWas.style.display = ''; elStWas.textContent = p.compare; } else { elStWas.style.display = 'none'; } }
      if (elStName) elStName.textContent = p.label + (p.qualifies ? ' + Free Program' : '');
      if (elStBtn)  elStBtn.textContent  = (p.hasCompare ? ('Add — ' + p.pct + '% Off →') : 'Add to Cart →');
      rebuildSizes();
      renderAddon();
      renderShipBar();
    }

    if (elPacks){
      $all('[data-kw-pack]', elPacks).forEach(function (b){
        b.addEventListener('click', function (){ selectPack(b.getAttribute('data-kw-pack')); });
      });
    }

    /* ---------- checkout ---------- */
    function checkout(btn){
      var p = pack();
      state._lastBtn = btn;
      if (p.sizeOpt > 0 && !state.size){
        var grp    = (btn && btn.closest) ? btn.closest('.hero-buybox, section') : null;
        var sizeEl = (grp && grp.querySelector('[data-kw-sizes]')) || sizeGroups[0];
        var warnEl = (grp && grp.querySelector('[data-kw-sizewarn]')) || warns[0];
        if (warnEl){ warnEl.textContent = 'Please select a size to continue.'; warnEl.classList.add('show'); }
        if (sizeEl){
          sizeEl.classList.remove('kw-shake'); void sizeEl.offsetWidth; sizeEl.classList.add('kw-shake');
          scrollToEl(sizeEl, 120);
          var firstBtn = sizeEl.querySelector('[data-kw-size]:not(.is-oos)');
          if (firstBtn){ try { firstBtn.focus({ preventScroll: true }); } catch (e){ firstBtn.focus(); } }
        }
        return;
      }
      var key = state.size || '';
      var v = p.variants[key];
      if (!v || !v.available){
        var w = warns[0];
        if (w){ w.textContent = 'That option is sold out — please pick another.'; w.classList.add('show'); }
        return;
      }
      /* upsell gate: offer the add-on once, unless it's already added or the popup is off */
      if (A && A.popup && !state.addonAdded && !state._upsellDone){
        openUpsell();
        return;
      }
      ctas.forEach(function (b){ b.classList.add('is-busy'); });
      var code = (cfg.codes && cfg.codes[0]) || '';
      var prog = (p.qualifies && cfg.programVariantId) ? cfg.programVariantId : 0;
      var addon = state.addonAdded ? addonVariantId() : 0;
      var items = v.id + ':1' + (prog ? (',' + prog + ':1') : '') + (addon ? (',' + addon + ':1') : '');
      var permalink = '/cart/' + items + (code ? ('?discount=' + encodeURIComponent(code)) : '');
      var target = cfg.checkoutTarget || '/checkout';
      var dest   = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target)) : target;
      var itemsArr = [{ id: v.id, quantity: 1 }];
      if (prog)  itemsArr.push({ id: prog,  quantity: 1 });
      if (addon) itemsArr.push({ id: addon, quantity: 1 });
      var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      function goAdd(){
        fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: itemsArr }) })
          .then(function (){ window.location.href = dest; })
          .catch(function (){ window.location.href = permalink; });
      }
      /* LP order tagging: stamp hidden cart attributes, then add + checkout (this path guarantees the tags land on the order) */
      var T = cfg.orderTag;
      if (T && T.enabled){
        var attrs = { '_lp': '1', '_lp_product': T.product || '', '_lp_template': T.template || '', '_lp_url': T.url || location.pathname };
        var pre = (cfg.buyNow !== false)
          ? fetch('/cart/clear.js', { method: 'POST', headers: H }).catch(function (){})
          : Promise.resolve();
        pre.then(function (){ return fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: attrs }) }); }).then(goAdd).catch(goAdd);
        return;
      }
      if (cfg.buyNow !== false){
        window.location.href = permalink;   // instant buy-now: cart permalink adds pack (+ free program + add-on) + applies the discount
        return;
      }
      /* add to the existing cart, then go to checkout — no clearing, no artificial delay */
      goAdd();
    }
    /* ---------- size popup (cta_mode = popup) ---------- */
    var ctaMode = cfg.ctaMode || 'inline';
    var popEl = null;
    function buildPopup(){
      if (popEl) return popEl;
      popEl = document.createElement('div');
      popEl.className = 'kw-pop';
      popEl.setAttribute('hidden', '');
      popEl.innerHTML =
        '<div class="kw-pop-bg" data-kw-pop-close></div>' +
        '<div class="kw-pop-card" role="dialog" aria-modal="true" aria-label="Select size">' +
          '<button type="button" class="kw-pop-x" data-kw-pop-close aria-label="Close">\u00d7</button>' +
          '<div class="kw-pop-title">Choose your size</div>' +
          '<div class="kw-pop-packs" data-kw-pop-packs></div>' +
          '<div class="kw-pop-sizes" data-kw-pop-sizes></div>' +
          '<div class="kw-pop-warn" data-kw-pop-warn></div>' +
          '<div class="kw-pop-note">Secure checkout \u00b7 30-day guarantee</div>' +
        '</div>';
      (lp || document.body).appendChild(popEl);
      if (cfg.buttonColor) popEl.style.setProperty('--kw-btn', cfg.buttonColor);
      popEl.addEventListener('click', function (e){ if (e.target.hasAttribute && e.target.hasAttribute('data-kw-pop-close')) closePopup(); });
      document.addEventListener('keydown', function (e){ if (e.key === 'Escape') closePopup(); });
      return popEl;
    }
    function renderPopup(){
      buildPopup();
      var p = pack();
      var packsWrap = popEl.querySelector('[data-kw-pop-packs]');
      if (cfg.packs.length > 1){
        packsWrap.style.display = '';
        packsWrap.innerHTML = cfg.packs.map(function (pp){
          return '<button type="button" class="kw-pop-pack' + (pp.id === state.packId ? ' on' : '') + '" data-kw-pop-pack="' + pp.id + '">' +
            '<span class="l">' + pp.label + (pp.qualifies ? ' + Free Program' : '') + '</span>' +
            '<span class="r">' + pp.price + (pp.hasCompare ? (' <s>' + pp.compare + '</s>') : '') + '</span></button>';
        }).join('');
        $all('[data-kw-pop-pack]', packsWrap).forEach(function (b){
          b.addEventListener('click', function (){ selectPack(b.getAttribute('data-kw-pop-pack')); renderPopup(); });
        });
      } else { packsWrap.style.display = 'none'; }
      var sizesWrap = popEl.querySelector('[data-kw-pop-sizes]');
      var html = '';
      if (p.sizes && p.sizes.length){
        p.sizes.forEach(function (s){
          var v = p.variants[s.handle]; var avail = !!(v && v.available);
          html += '<button type="button" class="kw-pop-size' + (avail ? '' : ' is-oos') + '" data-kw-pop-size="' + s.handle + '"' + (avail ? '' : ' aria-disabled="true"') + '>' + s.name + '</button>';
        });
      } else {
        html = '<button type="button" class="kw-pop-size" data-kw-pop-size="">Add to cart \u2192</button>';
      }
      sizesWrap.innerHTML = html;
      $all('[data-kw-pop-size]', sizesWrap).forEach(function (b){
        b.addEventListener('click', function (){
          if (b.getAttribute('aria-disabled') === 'true'){
            var w = popEl.querySelector('[data-kw-pop-warn]');
            if (w){ w.textContent = 'That size is sold out — pick another.'; w.classList.add('show'); }
            return;
          }
          state.size = b.getAttribute('data-kw-pop-size');
          syncSizeChecked();
          closePopup();
          checkout(b);
        });
      });
    }
    function openPopup(){ renderPopup(); popEl.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
    function closePopup(){ if (popEl){ popEl.setAttribute('hidden', ''); document.body.style.overflow = ''; } }

    /* ---------- CTA routing ---------- */
    function routeCta(btn){
      var local = btn.closest && (btn.closest('.offer') || btn.closest('.hero-buybox'));
      if (local){ checkout(btn); return; }          // button sits next to its own selector
      if (ctaMode === 'scroll'){ scrollToOffer(); return; }
      if (ctaMode === 'popup'){ openPopup(); return; }
      checkout(btn);                                  // inline
    }
    ctas.forEach(function (b){
      b.addEventListener('click', function (e){ if (b.tagName === 'A') e.preventDefault(); routeCta(b); });
    });

    initSticky();

    /* ---------- product-viewed (once; respects flag + consent) ---------- */
    if (!viewFired && cfg.view && cfg.view.fire){
      viewFired = true;
      try {
        var okv = true;
        if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'){
          okv = Shopify.customerPrivacy.analyticsProcessingAllowed();
        }
        if (okv){
          var p0 = pack();
          var value = (p0.priceCents || 0) / 100;
          var cur = cfg.currency || 'USD';
          var v0 = cfg.view;
          var vid = String(v0.variantId || v0.productId);
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){
            Shopify.analytics.publish('kewlioo:lp_product_viewed', {
              productId: v0.productId, variantId: v0.variantId, title: v0.title,
              handle: v0.handle, sku: v0.sku, value: value, currency: cur
            });
          }
          if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', { content_ids:[vid], content_name:v0.title, content_type:'product', value:value, currency:cur });
          if (typeof window.gtag === 'function') window.gtag('event', 'view_item', { currency:cur, value:value, items:[{ item_id:vid, item_name:v0.title }] });
          if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('ViewContent', { content_id:vid, content_type:'product', value:value, currency:cur });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event:'view_item', ecommerce:{ currency:cur, value:value, items:[{ item_id:vid, item_name:v0.title }] } });
        }
      } catch (e){}
    }

    selectPack(state.packId);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (){ init(); });
})();
